import { RobinJrLogoText, RobinLogo, RobinLogoText } from '@recruit-robin/robin-theme/web-icons';
import { routes } from 'config';
import { generateDtiAttribute } from 'helpers/helpers';
import { useGTM } from 'hooks/gtm';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRobinJrAppStore } from 'shared/config/useRobinJrApp';
import { useStyles } from './Logo.styles';
import { LogoProps } from './types';

const Logo = ({ to = routes.home, variant = 'default' }: LogoProps) => {
  const navigate = useNavigate();
  const classes = useStyles();
  const gtm = useGTM();
  const isRobinJrApp = useRobinJrAppStore((s) => s.isRobinJrApp);

  const onClickLogo = useCallback(() => {
    gtm.clickedRobinLogo();

    const route =
      to === routes.home ? (useRobinJrAppStore.getState().isRobinJrApp ? routes.robinJr.home : routes.home) : to;
    navigate(route);
  }, []);

  return (
    <div css={classes.root} onClick={onClickLogo} {...generateDtiAttribute('logo')}>
      {variant === 'text' ? (
        isRobinJrApp ? (
          <RobinJrLogoText height={24} color={(c) => c.neutral.variant[80]} />
        ) : (
          <RobinLogoText height={24} color={(c) => c.neutral.variant[80]} />
        )
      ) : (
        <RobinLogo height={24} />
      )}
    </div>
  );
};

export default Logo;
